export default "__VITE_ASSET__DoFNYRff__"